import { lazy } from 'react';

export const AgendaPage = lazy(() => import('@/pages/AgendaPage'));
export const ChangePasswordPage = lazy(() => import('@/pages/ChangePasswordPage'));
export const DashboardPage = lazy(() => import('@/pages/DashboardPage'));
export const CustomersPage = lazy(() => import('@/pages/CustomersPage'));
export const CustomerProfilePage = lazy(() => import('@/pages/CustomerProfilePage'));
export const DevPushPage = lazy(() => import('@/pages/DevPushPage'));
export const ForbiddenPage = lazy(() => import('@/pages/ForbiddenPage'));
export const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage'));
export const LoginPage = lazy(() => import('@/pages/LoginPage'));
export const OnboardingPage = lazy(() => import('@/pages/onboarding/OnboardingPage'));
export const ProfilePage = lazy(() => import('@/pages/ProfilePage'));
export const ProfessionalsPage = lazy(() => import('@/pages/ProfessionalsPage'));
export const ProductsPage = lazy(() => import('@/pages/ProductsPage'));
export const RbacPage = lazy(() => import('@/pages/RbacPage'));
export const RegisterPage = lazy(() => import('@/pages/RegisterPage'));
export const ResetPasswordPage = lazy(() => import('@/pages/ResetPasswordPage'));
export const SelectCompanyPage = lazy(() => import('@/pages/SelectCompanyPage'));
export const ServicesPage = lazy(() => import('@/pages/ServicesPage'));
export const SettingsPage = lazy(() => import('@/pages/SettingsPage'));
export const SetupPage = lazy(() => import('@/pages/SetupPage'));
export const WorkingHoursPage = lazy(() => import('@/pages/WorkingHoursPage'));
export const WalkInQueuePage = lazy(() => import('@/pages/WalkInQueuePage'));
